import { Link } from "react-router-dom";
import { useSiteContent } from "@/cms/SiteContentContext";
import { editableAttrs } from "@/cms/previewUtils";

const KinergoSection = () => {
  const { content } = useSiteContent();
  const section = content.home.kinergo;

  return (
    <section className="bg-zinc-900 py-16 md:py-20 border-y border-zinc-800" {...editableAttrs("home.kinergo", "object")}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="flex items-center gap-4 mb-5">
              <img src={section.logoSrc} alt={section.logoAlt} className="h-8 md:h-9 w-auto object-contain" loading="lazy" {...editableAttrs("home.kinergo.logoSrc", "image")} />
              <span className="text-red-500 text-xs md:text-sm font-bold tracking-widest" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs("home.kinergo.badge", "text")}>
                {section.badge}
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight mb-5" style={{ fontFamily: "Rajdhani, sans-serif" }}>
              <span {...editableAttrs("home.kinergo.title", "text")}>{section.title}</span>
              <br />
              <span className="text-red-500" {...editableAttrs("home.kinergo.titleAccent", "text")}>
                {section.titleAccent}
              </span>
            </h2>

            <p className="text-zinc-300 leading-relaxed mb-6 max-w-2xl" {...editableAttrs("home.kinergo.description", "textarea")}>
              {section.description}
            </p>

            <ul className="space-y-3 text-zinc-200" {...editableAttrs("home.kinergo.bullets", "array")}>
              {section.bullets.map((item, index) => (
                <li key={`${item}-${index}`} className="flex items-start gap-3">
                  <i className="ri-check-double-line text-red-500 text-lg mt-0.5"></i>
                  <span className="text-sm md:text-base">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-zinc-950 border border-zinc-700 p-7 md:p-8">
            <h3 className="text-white text-2xl font-bold mb-4" style={{ fontFamily: "Rajdhani, sans-serif" }} {...editableAttrs("home.kinergo.cardTitle", "text")}>
              {section.cardTitle}
            </h3>
            <p className="text-zinc-400 text-sm leading-relaxed mb-6" {...editableAttrs("home.kinergo.cardDescription", "textarea")}>
              {section.cardDescription}
            </p>

            <div className="flex flex-col gap-3">
              <Link
                to="/iletisim"
                className="w-full flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white py-3.5 font-bold tracking-wider transition-colors"
                style={{ fontFamily: "Rajdhani, sans-serif" }}
                {...editableAttrs("home.kinergo.cardPrimaryButtonLabel", "text")}
              >
                <i className="ri-calendar-check-line"></i>
                {section.cardPrimaryButtonLabel}
              </Link>
              <a
                href={`tel:${section.cardPhoneLabel.replace(/\D/g, "")}`}
                className="w-full flex items-center justify-center gap-2 border border-zinc-600 hover:border-red-600 text-zinc-200 hover:text-white py-3.5 font-bold tracking-wider transition-colors"
                style={{ fontFamily: "Rajdhani, sans-serif" }}
                {...editableAttrs("home.kinergo.cardPhoneLabel", "text")}
              >
                <i className="ri-phone-line"></i>
                {section.cardPhoneLabel}
              </a>
              <a
                href={`mailto:${section.cardEmailLabel}`}
                className="w-full flex items-center justify-center gap-2 border border-zinc-600 hover:border-red-600 text-zinc-200 hover:text-white py-3.5 font-bold tracking-wider transition-colors"
                style={{ fontFamily: "Rajdhani, sans-serif" }}
                {...editableAttrs("home.kinergo.cardEmailLabel", "text")}
              >
                <i className="ri-mail-line"></i>
                {section.cardEmailLabel}
              </a>
              <a href={section.productUrl} target="_blank" rel="noopener noreferrer" className="text-red-400 hover:text-red-300 text-sm mt-2" {...editableAttrs("home.kinergo.productUrlLabel", "text")}>
                {section.productUrlLabel}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KinergoSection;
